/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Check_RunningInputs */



/**
* | output |
* | --- |
* | "Checking your browser with Cloudflare. This can take a few seconds." |
*
* @param {Auth_X15_Check_RunningInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_x15_check_running = /** @type {((inputs?: Auth_X15_Check_RunningInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Check_RunningInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Checking your browser with Cloudflare. This can take a few seconds.")
});